import React from "react";
import SegmentPage from "../components/aa/SegmentPage";
import { TOURS_TRANSLATIONS, TOURS_IMAGES } from "../data/tours";

export default function ToursPage() {
  return <SegmentPage translations={TOURS_TRANSLATIONS} images={TOURS_IMAGES} />;
}
